import React, { useState } from "react";
import DatePicker from "../../components/datepicker/DatePickerWithText";
import { showToast } from "../../utils/utils";
import privateAxios from "../../utils/axiosPrivate";
import { getCustomerStatementURL } from "../../utils/constants/apiEndPoints";
import {
  showToastType,
  YYYYMMDD,
  All_OUTSTANDING_INVOICES
} from "../../utils/constants/appConstants";
import moment from "moment";
import { responseStatus, statementForm } from "../../locales/en";
import "./statement.scss";

const StatementForm = () => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};

    if (!startDate) {
      newErrors.startDate = statementForm?.errorValidation?.startDateValid;
    }

    if (!endDate) {
      newErrors.endDate = statementForm?.errorValidation?.endDateValid;
    }

    if (startDate && endDate && moment(startDate).isAfter(endDate)) {
      newErrors.dateRange = statementForm?.errorValidation?.startDateError;
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleDownloadPdf = async () => {
    if (!validateForm()) return;

    setLoading(true);
    try {
      const params = new URLSearchParams({
        quoteType: All_OUTSTANDING_INVOICES,
        startDate: moment(startDate).format(YYYYMMDD),
        endDate: moment(endDate).format(YYYYMMDD)
      });

      const response = await privateAxios.get(
        getCustomerStatementURL(params.toString()),
        {
          responseType: "blob"
        }
      );

      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `Statement_${moment(startDate).format("DD-MMM-YYYY")}_to_${moment(endDate).format("DD-MMM-YYYY")}.pdf`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      showToast(statementForm?.downloadSuccess, responseStatus.success);
      setErrors({});
    } catch (error) {
      const errorData = error.response?.data;
      let message;

      if (errorData instanceof Blob) {
        try {
          message = JSON.parse(await errorData.text())?.message;
        } catch {
          message = undefined;
        }
      } else {
        message = errorData?.message;
      }

      showToast(message || statementForm?.downloadError, showToastType.error);
    } finally {
      setLoading(false);
    }
  };

  const handleStartDateChange = (date) => {
    setStartDate(date);
    setErrors((prev) => ({
      ...prev,
      startDate: undefined,
      dateRange: undefined
    }));
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
    setErrors((prev) => ({
      ...prev,
      endDate: undefined,
      dateRange: undefined
    }));
  };

  return (
    <div className="statement-form-container">
      <div className="statement-card">
        <div className="row align-items-center">
          <div className="col-md-5">
            <div className="date-input-wrap">
              <label>{statementForm?.startDate}</label>
              <div className="input-error-wrapper">
                <DatePicker
                  value={startDate}
                  onChange={handleStartDateChange}
                  placeholder={statementForm?.startDate}
                />
                <div className="error-msg">
                  {errors.startDate && (
                    <div className="text-danger small">{errors.startDate}</div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-5">
            <div className="date-input-wrap">
              <label>{statementForm?.endDate}</label>
              <div className="input-error-wrapper">
                <DatePicker
                  value={endDate}
                  onChange={handleEndDateChange}
                  placeholder={statementForm?.endDate}
                />
                <div className="error-msg">
                  {errors.endDate && (
                    <div className="text-danger small">{errors.endDate}</div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        {errors.dateRange && (
          <div className="text-danger small mt-3 text-center">
            {errors.dateRange}
          </div>
        )}
      </div>
      <div className="download-btn-wrap">
        <button
          className="btn btn-download-pdf"
          onClick={handleDownloadPdf}
          disabled={loading}
        >
          {loading ? statementForm?.downloading : statementForm?.downloadBtn}
          <i className="fa fa-file-pdf-o ms-2" />
        </button>
      </div>
    </div>
  );
};

export default StatementForm;
